import { useContext, useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { AppThemingContext } from '@/containers/AppTheming/Context';
import { Permission } from '@/enums/permission';
import { AppInitializing } from '@/screens/Initializing';
import { useAppSelector } from '@/store';
import { getAppDefaultPaths } from './utils';

export function BrandingInitializedGuard(props: ChildrenProps) {
  const { query } = useContext(AppThemingContext);
  const brandingInitialized = useMemo(() => !query.isPlaceholderData && !query.isFetching, [query.isPlaceholderData, query.isFetching]);

  if (!brandingInitialized) return <AppInitializing />;

  return props.children;
}

type AuthenticatedGuardProps = {
  children: React.ReactNode;
  unauthenticatedRedirectPath?: string;
};

export function BrandingAccessGuard(props: AuthenticatedGuardProps) {
  const defaultPaths = getAppDefaultPaths();
  const hasBrandingPermission = useAppSelector(state => state.user.permissions.includes(Permission.BrandingMain));

  if (!hasBrandingPermission) {
    return (
      <Navigate
        to={props.unauthenticatedRedirectPath || defaultPaths.home}
        replace />
    );
  }

  return props.children;
}